import React, { FunctionComponent } from "react";
import { useSelector } from "react-redux";

import Form from "../form";
import { ImageUploadInputProps } from "../form/imageUploadInput";

import * as templateHelper from "./templateHelper";
import { getLoadErrorMessage } from './fieldErrorOnLoad';

interface TemplateImageUploadProps extends Omit<ImageUploadInputProps, "onChange" | "url"> {
  path: string;
  validation?: {
    required?: boolean;
  };
  radioLabel?: string;
  onChange: (path: string, value: any) => void;
}

export const TemplateImageUpload: FunctionComponent<TemplateImageUploadProps> = ({
  path,
  label,
  subtext,
  validation,
  position = "left",
  radioLabel,
  onChange,
  ...rest
}) => {
  const url = useSelector((state: any) => templateHelper.getValue(state.templateBuilderEx, path));
  const disabled = useSelector((state: any) => templateHelper.getState(state.templateBuilderEx, path, "disabled"));
  const validationErrorMessage = useSelector((state: any) =>
    getLoadErrorMessage(state.templateBuilderEx, path, validation)
  );

  const translations = {
    label: templateHelper.getTranslation(label) || undefined,
    subtext: templateHelper.getTranslation(subtext) || undefined,
  };

  return (
    <Form.ImageUploadInput
      {...rest}
      {...translations}
      url={url}
      disabled={rest.disabled !== undefined ? rest.disabled : disabled}
      required={validation?.required}
      validationErrorMessage={validationErrorMessage}
      position={position}
      onChange={(url) => onChange(path, url || null)}
    />
  );
};
